import React from "react";
import {Link, useNavigate} from "react-router-dom";
import {useSession} from "@/hook/useSession";
import {useDialog} from "@/dialog/DialogContext";
import {BottomSheetMenu} from "@/common/BottomSheetMenu";
import styled from "styled-components";
import {FtColors} from "@/FtColors";
import {Device} from "@/store/Device";
import {ApiClient} from "@/api/ApiClient";

const Wrap = styled.div`
    height: 50px;
    min-height: 50px;
    background-color: ${FtColors.primary};
    color: #fff;
    display: flex;
    align-items: center;

    .title {
        font-size: 1.2rem;
        font-weight: bold;
        padding: 0 16px;
    }

    .menu-items, .right {
        a, span {
            color: #fff;
            text-decoration: none;
            padding: 0 8px;
            font-size: 0.9rem;
            cursor: pointer;
        }
    }

    .right {
        padding-right: 16px;
    }
`;

interface Props {
    onTransMultiAdd?: () => void;
}

export function AppNavBar(props: Props) {
    const session = useSession();
    const dialog = useDialog();
    const navigate = useNavigate();
    const [bottomSheetOpen, setBottomSheetOpen] = React.useState(false);

    const menuItems = [
        {name: "전체 요약", onClick: () => navigate('/')},
        {name: "거래건 검색", onClick: () => navigate('/transactions')},
        {name: "용돈 한도", onClick: () => navigate('/TransLimit')},
        {name: "월별 요약", onClick: () => navigate('/MonthlySummary')},
        {name: "계정 관리", onClick: () => navigate('/accounts')},
        {name: "메모", onClick: () => navigate('/Memo')},
        {name: "로그아웃", onClick: () => ApiClient.instance.logout()},
    ];

    return (
        <Wrap>
            <div className="title">가계부</div>
            <div className="menu-items">
                <Link to="/">전체 요약</Link>

                {!Device.isMobile && (<>
                    <Link to="/transactions">거래건 검색</Link>
                    <Link to="/TransLimit">용돈 한도</Link>
                    <Link to="/MonthlySummary">월별 요약</Link>
                    <Link to="/accounts">계정 관리</Link>
                    <Link to="/Memo">메모</Link>
                    <span onClick={() => props.onTransMultiAdd?.()}>멀티 등록</span>
                </>)}

                <span onClick={() => dialog.openDialog('addTrans', {})}>거래 등록</span>
            </div>

            <div style={{flex: 1}}></div>

            <div className="right">
                {Device.isMobile && (
                    <span onClick={() => setBottomSheetOpen(true)}>...</span>
                )}
                {!Device.isMobile && (
                    <span onClick={() => ApiClient.instance.logout()}>로그아웃</span>
                )}
            </div>

            {bottomSheetOpen && (
                <BottomSheetMenu items={menuItems} handleClose={() => setBottomSheetOpen(false)}/>
            )}
        </Wrap>
    );
}
